import { render, staticRenderFns } from "./MediaDetailView.vue?vue&type=template&id=a378df4e&scoped=true"
import script from "./MediaDetailView.vue?vue&type=script&lang=js"
export * from "./MediaDetailView.vue?vue&type=script&lang=js"
import style0 from "./MediaDetailView.vue?vue&type=style&index=0&id=a378df4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a378df4e",
  null
  
)

export default component.exports